import { create } from 'zustand';

import { KeyImage, KeyImageLabel } from '@/api';

import { KeyImagesState } from './use-key-images.model';

export const useKeyImagesStore = create<KeyImagesState>((set) => ({
  isKeyImagesError: false,
  isKeyImagesLoading: false,
  keyImageLabels: [],
  keyImages: [],

  setIsKeyImagesError: (isKeyImagesError: boolean) => set({ isKeyImagesError }),

  setIsKeyImagesLoading: (isKeyImagesLoading: boolean) => set({ isKeyImagesLoading }),

  setKeyImageLabels: (keyImageLabels: KeyImageLabel[]) => set({ keyImageLabels }),

  setKeyImages: (keyImages: KeyImage[]) => set({ keyImages }),

  setShouldRefetchKeyImages: (shouldRefetchKeyImages: boolean) => set({ shouldRefetchKeyImages }),

  shouldRefetchKeyImages: false,

  updateKeyImageLabel: (updatedLabel: KeyImageLabel) => {
    set((state) => {
      const updatedLabels = state.keyImageLabels.map((item) => ({
        ...item,
        label: item.uuid === updatedLabel.uuid ? updatedLabel.label : item.label,
      }));

      return {
        keyImageLabels: updatedLabels,
      };
    });
  },
}));
